import { saveAs } from 'file-saver';
import { axiosInstance } from 'api/instance';

const DEFAULT_ERROR = 'Could not download the file. Try again.';

const ERROR_MESSAGES = {
  nothing_to_export: 'No stones match this selection.',
  gpx_over_limit: 'A GPX file holds at most 500 stones.',
  field_area_unknown: 'This field has no known area.',
  survey_closed: 'This survey is finalised.'
};

export const exportFilename = disposition => {
  const match = /filename="?([^";]+)"?/.exec(disposition ?? '');
  return match ? match[1] : null;
};

export const exportErrorMessage = code => ERROR_MESSAGES[code] ?? DEFAULT_ERROR;

export const downloadExport = async ({ surveyId, format, capPerAcre }) => {
  const response = await axiosInstance.post(
    `/surveys/${surveyId}/exports`,
    { format, cap_per_acre: capPerAcre },
    { responseType: 'blob', skipErrorModal: true }
  );
  const filename = exportFilename(response.headers['content-disposition']) ?? 'stones';
  saveAs(response.data, filename);
  return filename;
};

export const readExportError = async error => {
  const body = error?.data;
  if (!(body instanceof Blob)) return DEFAULT_ERROR;
  try {
    return exportErrorMessage(JSON.parse(await body.text()).code);
  } catch (parseError) {
    return DEFAULT_ERROR;
  }
};
